import oauthConfig from "../../../oauth.config";
import api_config from "../../../settings/api.config";
import { fetcher } from "../handler";
const hostname = api_config.hostname;

const postSignup = (values) => {
  //@TODO: Finish Post Request
  return fetcher(
    [
      hostname + "/signup",
      {
        method: "POST",
        body: values,
        headers: {
          Accept: "application/json",
        },
      },
    ],
    true,
  );
};

const postVerification = (token, code) => {
  return fetcher(
    [
      hostname + `/verify?token=${token}&verify=${code}`, 
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          oauth_consumer_key: oauthConfig.oauth_consumer_key, 
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret
        },
      },
    ],
    false, true
  )
}


export { postSignup, postVerification };

